import { headerSignInStyles as styles } from "@insite/content-library/Widgets/Common/HeaderSignIn";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import { colorStrings } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.titleIcon = {
    ...styles.titleIcon,
    size: 17,
    color: colorStrings.primaryMain,
};

styles.titleTypography = {
    ...styles.titleTypography,
    color: colorStrings.commonGlobalGray01,
    size: "18px",
    lineHeight: "20px",
    transform: "none",
};

styles.titleClickable = {
    ...styles.titleClickable,
    css: css`
        ${styles.titleClickable?.css}

        &:hover {
            text-decoration: underline;

            ${IconWrapper} {
                color: ${getColor(colorStrings.primaryMain)};
            }

            ${TypographyStyle} {
                color: ${getColor(colorStrings.primaryMain)};
            }
        }
    `,
};

styles.signOutClickable = {
    ...styles.signOutClickable,
    css: css`
        ${styles.signOutClickable?.css}
        color: ${getColor(colorStrings.commonGlobalGray01)};
        font-size: 18px;
        line-height: 20px;
        text-transform: none;

        &:hover {
            color: ${getColor(colorStrings.primaryMain)};
            text-decoration: underline;
        }
    `,
};
